import React from "react";
import { useScreenSubscription } from "../../pages/subscription/screenProviderLocationAccount";
import { formatMobileNumber } from "./const";
import ChildAccountsDetailBase from "./childAccountsDetailBase";
import { WORK_FLOW_COMMON_SCREENS, WORK_FLOW_LOCATION_ACCOUNT } from "../../pages/subscription/const";
import { useNavigate } from "react-router-dom";
import { ROUTER_NAME } from "../../router/routers";
import { useGetPaymentMethods } from "../../hooks/usePayment";
import { useCreateVendorSubscription } from "../../hooks/useSubscriptions";
import { messageManager, MESSAGE_TYPE, translate } from "../../helper";

export const ChildAccountsDetailDynamic = () => {
    const { childAccount, setChildAccount, goBack , screenStack, setScreenStack, navigateTo, triggerRefresh, selectedSubscription, setScreen  } = useScreenSubscription();
    const [currentMobileNumber, setCurrentMobileNumber] = React.useState('');
    const navigate = useNavigate()

    const { paymentMethods, isLoading: isLoadingPaymentMethods } = useGetPaymentMethods();

    const { createVendorSubscription, isCreatingSubscription } = useCreateVendorSubscription(
        () => {
            messageManager({ type: MESSAGE_TYPE.success, messageShow: translate('successfullySubscribed') || 'Successfully subscribed' });
            triggerRefresh();
        },
        (data) => {
            messageManager({ type: MESSAGE_TYPE.error, messageShow: data?.error || translate('subscriptionFailed') || 'Subscription failed' });
            triggerRefresh();
        }
    );

    const childAccountId = childAccount?.id || null;

    const isNew = (childAccountId === null || childAccountId === 'new') ? true : false;
    
    React.useEffect(() => {
        if (isNew) {
            setChildAccount(prev => prev || {});
            return;
        }
        if (childAccount?.mobile_number) {
            setCurrentMobileNumber(formatMobileNumber(childAccount.mobile_number));
        }
    }, [isNew, childAccount?.mobile_number]);

    const handlePay = (newChildAcc) => {
        if (!selectedSubscription) {
            messageManager({ type: MESSAGE_TYPE.error, messageShow: translate('noSubscriptionSelected') || 'No subscription selected' });
            return;
        }
        const locationId = (newChildAcc?.id) || (childAccount?.id);
        const payload = locationId ? {
            child_account_id: locationId,
            subscription_id: selectedSubscription?.paymentId,
        } : {
            subscription_id: selectedSubscription?.paymentId,
        };
        createVendorSubscription(payload);
    };

    const goPaymentInfo = (newChildAcc) => {
        const defaultMethod = (paymentMethods || []).find(pm => pm?.is_default);
        if (defaultMethod && !isLoadingPaymentMethods) {
            handlePay(newChildAcc);
            return;
        }
        navigateTo(WORK_FLOW_COMMON_SCREENS.PAYMENT_INFO);
        setScreenStack(prevStack => [
            ...prevStack,
            WORK_FLOW_LOCATION_ACCOUNT.ACTIVE_LOCATION_SUBSCRIPTION,
            WORK_FLOW_COMMON_SCREENS.PAYMENT_INFO
        ]);
    }
    const goPrevious = () => {
        navigate(ROUTER_NAME.subscription, {
            state: {
                initialTab: 'location',
            },
        });
    }

    const goChildAccounts = () => {
        setScreen(WORK_FLOW_LOCATION_ACCOUNT.ACTIVE_LOCATION_SUBSCRIPTION);
        navigate(ROUTER_NAME.subscription, {
            state: {
                initialTab: 'location',
                initialScreen: WORK_FLOW_LOCATION_ACCOUNT.ACTIVE_LOCATION_SUBSCRIPTION,
            },
        });
    }

    const showBackButton = !isNew;

    return (
        <ChildAccountsDetailBase
            childAccount={childAccount}
            selectedSubscription={selectedSubscription}
            currentMobileNumber={currentMobileNumber}
            goBack={goBack}
            goChildAccounts={goChildAccounts}
            goPaymentInfo={(newChildAcc) => goPaymentInfo(newChildAcc)}
            setChildAccount={setChildAccount}
            isNew={isNew}
            title={''}
            showBackButton={showBackButton}
            isCreatingSubscription={isCreatingSubscription}
            goPrevious={goPrevious}
        />
    )

}
